import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { Box, Dialog, DialogActions, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

// Styled container for the display field
const TimeRangeContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  cursor: 'pointer',
  width: '100%'
}));

export default function CalendarTimePicker({startDateTime, endDateTime, sendTimeDataFromChild}) {
    const { t } = useTranslation(); 
    const [startTime, setStartTime] = useState(dayjs(startDateTime));
    const [endTime, setEndTime] = useState(dayjs(endDateTime));
    const [open, setOpen] = useState(false);
    const displayValue = `${startTime.format('hh:mm A')} - ${endTime.format('hh:mm A')}`;

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleSave = () => {
        if (endTime.isBefore(startTime)) {
            alert('End time must be after start time');
            return;
        }
        setOpen(false);
        sendTimeDataFromChild({"fromTime" : startTime.$d, "toTime": endTime.$d});
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimeRangeContainer  className="relative">
                <div onClick={open ? handleClose : handleOpen} className='flex justify-between items-center w-full'>
                    <Box component="span">{displayValue}</Box>
                    <img className='w-5 h-5' src="../../assets/icons/profile/icon/hour.svg" alt='hour' />
                </div>
                {open && (
                    <div className='absolute z-50 bg-white shadow-md border border-gray-50 w-60 top-8 -left-4 p-1 rounded-md'>
                        <Box sx={{ p: 2 }} className="space-y-2">
                            <TimePicker
                                label="Start Time"
                                value={startTime}
                                onChange={(newValue) => setStartTime(newValue)}
                            />
                            <TimePicker
                                label="End Time"
                                value={endTime}
                                onChange={(newValue) => setEndTime(newValue)}
                            />
                        </Box>
                        <div className="flex justify-end space-x-2 items-center">
                            <button onClick={handleSave} className="px-4 py-2 bg-blue-normal text-white rounded-lg capitalize">
                                { t('save')}
                            </button>
                        </div>
                    </div>
                )}
            </TimeRangeContainer>
        </LocalizationProvider>
    );
}
